import { sharedEnvironment } from '@vinnova/environments';

const bedomningsPortalApiBaseURI = `${sharedEnvironment.sys.gatewayUrl}/bedomningsportal`;

export const environment = {
  production: sharedEnvironment.sys.production,
  name: sharedEnvironment.sys.name,
  etjansterCommonUrl: sharedEnvironment.sys.etjansterCommonUrl,
  ansokanUrl: sharedEnvironment.sys.ansokanUrl,
  bpUrl: sharedEnvironment.sys.bpUrl,
  cookieDomain: sharedEnvironment.sys.cookieDomain,
  bedomningsPortalApiUrl: bedomningsPortalApiBaseURI,
  etjansterCommonApiUrl: `${sharedEnvironment.sys.gatewayUrl}/etjanster`,
  resourceStringUrl: `${sharedEnvironment.sys.gatewayUrl}/resourcestring/BP`,
  projektUrl: sharedEnvironment.sys.projektUrl,
  externalLinks: sharedEnvironment.sys.externalLinks,
  baseGatewayUrl: sharedEnvironment.sys.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.sys.apimSubscriptionKey,
  chatbotApiUrl: bedomningsPortalApiBaseURI + '/chatbot',
  b2cMsalConfig: {
    ...sharedEnvironment.b2cMsalConfig(
      bedomningsPortalApiBaseURI,
      sharedEnvironment.sys.azureAdB2C.clientId.bedomningsportalClientId,
      sharedEnvironment.sys.azureAdB2C.clientId.bedomningsportalApiClientId,
    ),
    authority: sharedEnvironment.sys.azureAdB2C.authority,
    scope: `https://${sharedEnvironment.sys.azureAdB2C.tenant}.onmicrosoft.com/${sharedEnvironment.sys.azureAdB2C.clientId.bedomningsportalApiClientId}/all`,
    tenant: sharedEnvironment.sys.azureAdB2C.tenant,
    policies: sharedEnvironment.sys.azureAdB2C.policies,
    clientId: sharedEnvironment.sys.azureAdB2C.clientId,
  },
};
